// ========================================
// Widget: RRHH — Fuera esta semana
// Vacaciones y permisos sin sueldo aprobados que caen de lunes a viernes de esta
// semana (GET /api/staff-leaves/overview): cuántas personas faltan cada día y quiénes.
// ========================================

window.DashboardWidgets = window.DashboardWidgets || {};
window.DashboardWidgets.rrhh = window.DashboardWidgets.rrhh || {};

window.DashboardWidgets.rrhh.fueraSemana = function(ctx) {
    const { leaves, week = [] } = ctx;
    const W = window.DashboardWidgets.rrhh;
    const away = leaves && leaves.away ? leaves.away : null;
    const outOn = iso => (away || []).filter(l => l.startDate <= iso && l.endDate >= iso).length;
    const until = l => l.endDate >= week[week.length - 1].iso ? (l.startDate <= week[0].iso ? 'Toda la semana' : `Desde el ${W.shortDate(l.startDate)}`)
        : l.startDate === l.endDate ? `El ${W.shortDate(l.startDate)}` : `Hasta el ${W.shortDate(l.endDate)}`;

    const list = leaves && leaves.error ? '<div class="rp-empty">No se pudieron cargar las ausencias.</div>'
        : !away ? '<div class="rp-empty"><i class="fas fa-spinner fa-spin"></i> Cargando…</div>'
        : !away.length ? '<div class="rp-empty">Nadie tiene vacaciones ni permisos esta semana.</div>'
        : away.map(l => `<div class="rp-row">
            <span class="rp-row-text"><span class="rp-row-name">${Utils.sanitizeHTML(l.name || 'Persona')}</span><span class="rp-row-detail">${Utils.sanitizeHTML(until(l))}</span></span>
            <span class="rp-badge ${l.kind === 'unpaid' ? 'is-warn' : 'is-ok'}">${l.kind === 'unpaid' ? 'Sin sueldo' : 'Vacaciones'}</span>
        </div>`).join('');

    const inner = `
        <div class="rp-card-head">
            <h2 class="rp-card-title">Fuera esta semana</h2>
            <span class="rp-muted">${week.length ? `${W.shortDate(week[0].iso)} – ${W.shortDate(week[week.length - 1].iso)}` : ''}</span>
        </div>
        <div class="rp-week">
            ${week.map(d => `<div class="rp-day ${d.today ? 'is-today' : ''}" aria-label="${d.label}: ${away ? outOn(d.iso) : 'sin datos'} fuera">
                <span class="rp-day-label">${d.label}</span><span class="rp-day-n">${away ? outOn(d.iso) : '·'}</span></div>`).join('')}
        </div>
        <div>${list}</div>`;
    return W.card(ctx, inner);
};
